import { getEnvConfig } from '@app/env.config';
import zendeskSandboxFields from '@app/constants/messages/zendesk.config.sandbox';

export default function staticConfigs() {
  const { ZENDESK_ENV } = getEnvConfig();
  return {
    messages: ZENDESK_ENV !== `PROD` ? zendeskSandboxFields : null,
  };
}
